module.exports = __webpack_public_path__ + "img/gernzhifu_none.9d76654a.png";